import createCtx from 'coreUtils/createCtx';

export const [useBadgesCtx, BadgesProvider, BadgesConsumer] = createCtx<{
	badgesList: string[];
}>();
